<content-panel>
    <panel-header [heading]="serialNumber">
        <button mat-icon-button matTooltip="Close" (click)="closePanel()">
            <mat-icon>close</mat-icon>
        </button>
    </panel-header>
    <panel-body class="detail-view-container">
        <section class="row">
            <section class="column">
                <div class="body">
                    <div class="detail-view-element">
                        <label for="">Serial Number</label>
                        <div>{{ defectViewItem?.SerialNumber }}</div>
                    </div>
                    <div class="detail-view-element">
                        <label for="">Status</label>
                        @if(defectViewItem?.Status === 'Complete') {
                            <span class="complete">
                                <b>{{ defectViewItem?.Status }}</b>
                            </span>
                        } @else {
                            <span class="in-progress">
                                <b>{{ defectViewItem?.Status }}</b>
                            </span>
                        }
                    </div>
                </div>
            </section>
            <section class="column">
                <div class="body">
                    <div class="detail-view-element">
                        <label for="">Creation On</label>
                        <div>{{ defectViewItem?.CreationDate }}</div>
                    </div>
                    <div class="detail-view-element">
                        <label for="">Completed On</label>
                        <div>{{ defectViewItem?.CompletedDate }}</div>
                    </div>
                </div>
            </section>
            <section class="column">
                <div class="body">
                    <div class="detail-view-element">
                        <label for="">Completed By</label>
                        <div>{{ defectViewItem?.CompletedBy }}</div>
                    </div>
                    <div class="detail-view-element">
                        <label for="">Defect Count</label>
                        <div>{{ defectViewItem?.DefectCount }}</div>
                    </div>
                </div>
            </section>
        </section>
        <section class="row">
            <div class="header no-border">Defect History</div>
        </section>
        <section class="row scrollable">
            <table 
                mat-table
                [dataSource]="testData"
            >
                <ng-container matColumnDef="ZoneName">
                    <th mat-header-cell *matHeaderCellDef class="column-zone">
                        <b>Zone</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-zone">
                        {{element.ZoneName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Section">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Section</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center">
                        {{element.Section}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Station">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Station</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center">
                        {{element.Station}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="TaskName">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Task Name</b>
                    </th>
                    <td mat-cell *matCellDef="let element" 
                    class="text-column"
                    [matTooltip]="element.TaskName">
                        {{element.TaskName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Category">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Category</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center">
                        {{element.Category}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Code">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Code</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center">
                        {{element.Code}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="DefectLoc">
                    <th mat-header-cell *matHeaderCellDef class="column-center loc-and-quantity">
                        <b>Defect Location</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center loc-and-quantity">
                        {{element.DefectLoc}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="DefectQuantity">
                    <th mat-header-cell *matHeaderCellDef class="column-center loc-and-quantity">
                        <b>Defect Quantity</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center loc-and-quantity">
                        {{element.DefectQuantity}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="DefectDesc">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Description</b>
                    </th>
                    <td mat-cell *matCellDef="let element" 
                    class="text-column"
                    [matTooltip]="element.DefectDesc">
                        {{element.DefectDesc}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Images">
                    <th mat-header-cell *matHeaderCellDef class="photo-column">
                        <b>Image(s)</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="photo-column">
                        @for(image of element.Images; track image) {
                            <span class="photo-name" (click)="previewPhoto(image)">
                                {{image}}
                            </span>
                        }
                    </td>
                </ng-container>
                <tr
                    mat-header-row
                    *matHeaderRowDef="tableColumns"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="
                    let row;
                    columns: tableColumns
                    "
                ></tr>
            </table>
        </section>
    </panel-body>
</content-panel>
